import React, { useEffect } from 'react';
import useThemeStore from '@/store/useThemeStore';

const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
   const { mode } = useThemeStore();

   useEffect(() => {
      document.documentElement.dataset.theme = mode;
   }, [mode]);

   return <>{children}</>;
};

export default ThemeProvider;
